import React, {useEffect, useState} from 'react'
import parseToken from "../../../helpers/parseToken"
import {message, Spin} from "antd"
import BlockLeft from "./layout/default/block-left/BlockLeft"
import CustomerHubDetailProvider from "./CustomerHubDetailProvider"
import BlockCenter from "./layout/default/block-center/BlockCenter"
import getHistory from "../../../store/getHistory"
import {
    getListIp,
    getListShortPhoneByTenant,
    getListTenantFee,
    getListTenantNumber,
    getListTenantRouting,
    searchTelco,
    searchTenantHub
} from "../../../services/api/apiCustomerHub";
import BlockTop from "./layout/default/block-top/BlockTop";
import ParamConfiguration from "./layout/default/block-left/ParamConfiguration"

function CustomerHubDetailPage(props) {
    const decodeToken = parseToken()
    const {custId, onChangeMainTab, onChangeActiveTab} = props

    const [loading, setLoading] = useState(false)
    const [listTelco, setListTelco] = useState([])
    const [listRoutingBlock, setListRoutingBlock] = useState([])
    const [listTenantFee, setListTenantFee] = useState([])
    const [listTenantIP, setListTenantIP] = useState([])
    const [customerInformation, setCustomerInformation] = useState({})
    const [listTenantNumber, setListTenantNumber] = useState([])
    const [shortPhone, setShortPhone] = useState([])

    const _fetchCustomerDetail = async () => {
        return new Promise(async (resolve, reject) => {
            try {
                const payload = {
                    id: custId,
                }
                const response = await searchTenantHub(decodeToken.sub, payload)
                resolve(response)
            } catch (e) {
                reject(e.message)
            }
        })
    }

    const _onActiveTabDefault = value => {
        const history = getHistory()
        history.push('/crm/customers-hub')
        onChangeMainTab({id: 'customersHub', title: 'Quản lý khách hàng', icon: ''})
        onChangeActiveTab({id: 'customersHub'})
    }

    const _fetchTelco = async () => {
        try {
            const response = await searchTelco(decodeToken.sub)

            const {success, data} = response

            if (parseInt(success) !== 1) {
                setLoading(false)
                return
            }
            setListTelco(data)
        } catch (e) {
            console.log(e.message)
        }
    }

    const _fetchTenantRouting = async () => {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await getListTenantRouting(decodeToken.sub, custId)

                await resolve(response)
            } catch (e) {
                reject(e.message)
            }
        })
    }

    const _fetchTenantFee = async () => {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await getListTenantFee(decodeToken.sub, custId)
                await resolve(response)
            } catch (e) {
                reject(e.message())
            }
        })
    }

    const _fetchTenantListIP = async () => {
        return new Promise(async (resolve, reject) => {
            try {
                const payload = {
                    tenantId: custId
                }
                const response = await getListIp(decodeToken.sub, payload)
                resolve(response)
            } catch (e) {
                reject(e.message())
            }
        })
    }

    const _fetchListTenantNumber = async () => {
        return new Promise(async (resolve, reject) => {
            try {
                const payload = {
                    tenantId: custId
                }
                const response = await getListTenantNumber(decodeToken.sub, payload)
                await resolve(response)
            } catch (e) {
                reject(e.message())
            }
        })
    }

    const getCustomerDetail = async () => {
        await _fetchCustomerDetail().then((response) => {
            const {success, data} = response
            if (parseInt(success) !== 1) {
                return setLoading(false)
            }
            setLoading(false)
            setCustomerInformation(data[0])
        }).catch((e) => {
            message.error(e.message)
        });
    }

    const getTenantRouting = async () => {
        await _fetchTenantRouting().then((response) => {
            const {success, data} = response
            if (parseInt(success) !== 1) {
                return setLoading(false)
            }
            setLoading(false)
            setListRoutingBlock(data)
        }).catch((e) => {
            message.error(e.message)
        });
    }

    const getTenantFee = async () => {
        await _fetchTenantFee().then((response) => {
            const {success, data} = response
            if (parseInt(success) !== 1) {
                return setLoading(false)
            }
            setLoading(false)
            setListTenantFee(data)
        }).catch((e) => {
            message.error(e.message)
        });
    }

    const getTenantListIP = async () => {
        await _fetchTenantListIP().then((response) => {
            const {success, data} = response
            if (parseInt(success) !== 1) {
                return setLoading(false)
            }
            setLoading(false)
            setListTenantIP(data.filter(item => item.tenantId === custId))
        }).catch((e) => {
            message.error(e.message)
        });
    }

    const getListTenantNumberPhone = async () => {
        await _fetchListTenantNumber().then((response) => {
            const {success, data} = response
            if (parseInt(success) !== 1) {
                return setLoading(false)
            }
            setLoading(false)
            setListTenantNumber(data.map((item, index) => {
                return {
                    key: index,
                    ...item
                }
            }))
        }).catch((e) => {
            message.error(e.message)
        });
    }

    const getListShortPhone = async () => {
        await _fetchListShortPhone().then((response) => {
            const {success, data} = response
            if (parseInt(success) !== 1) {
                return setLoading(false)
            }
            const _shortPhone = data.map(item => {
                return {
                    label: item.shortPhone,
                    name: item.shortPhone,
                    value: item.shortPhone,
                }
            })

            setShortPhone([..._shortPhone])
        }).catch((e) => {
            message.error(e.message)
        })
    }

    const _fetchListShortPhone = async () => {
        return new Promise(async (resolve, reject) => {
            try {
                const payload = {
                    tenantId: custId
                }
                const response = await getListShortPhoneByTenant(decodeToken.sub, payload)
                await resolve(response)
            } catch (e) {
                reject(e.message())
            }
        })
    }

    const _fetchData = async () => {
        await getCustomerDetail()
        await getTenantRouting()
        await getTenantFee()
        await getTenantListIP()
        await getListTenantNumberPhone()
        await getListShortPhone()
    }

    useEffect(() => {
        _fetchTelco()
        _fetchData()
        // eslint-disable-next-line
    }, [])

    return (
        <CustomerHubDetailProvider
            customerInformation={customerInformation}
        >
            <Spin spinning={loading}>
                <div className="CaseDetailPage">
                    <div className="HeadPage">
                        <div className="Heading">
                            <span onClick={_onActiveTabDefault}>
                                <span className="material-icons">arrow_back</span>
                                <span className="Title">Back to list</span>
                            </span>
                            <div className="Company">
                                <span className="material-icons">person</span>
                                <span className="Name">{customerInformation.tenantFullName}</span>
                            </div>
                        </div>
                        <div className="Actions">
                        </div>
                    </div>
                    <div className="blockTop">
                        <BlockTop
                            setCustomerInformation={setCustomerInformation}
                            custId={custId}
                            customerInformation={customerInformation}
                            fetchCustomerDetail={getCustomerDetail}
                        />
                    </div>
                    <div className="row">
                        <div className="col-12 Block1">
                            <>
                                <BlockLeft
                                    listTelco={listTelco}
                                    custId={custId}
                                    listTenantNumber={listTenantNumber}
                                    shortPhone={shortPhone}
                                    fetchListTenantNumber={getListTenantNumberPhone}
                                />
                                <ParamConfiguration tenantId={custId}/>
                            </>
                        </div>
                        <div className="col-12 Block2 mt-3">
                            <BlockCenter
                                custId={custId}
                                listTelco={listTelco}
                                listRoutingBlock={listRoutingBlock}
                                listTenantFee={listTenantFee}
                                listTenantIP={listTenantIP}
                                tenantFullName={customerInformation.tenantFullName}
                                fetchCustomerDetail={getCustomerDetail}
                                fetchTenantRouting={getTenantRouting}
                                fetchTenantFee={getTenantFee}
                                fetchTenantListIP={getTenantListIP}
                            />
                        </div>
                    </div>
                </div>
            </Spin>
        </CustomerHubDetailProvider>
    )
}

export default CustomerHubDetailPage
